import React from 'react';
import { FaBell, FaSearch, FaUserCircle, FaBars } from 'react-icons/fa';
import { useAdminAuth } from '../context/AdminAuthContext';

// Define Props
interface AdminHeaderProps {
  onMenuToggle: () => void;
}

const AdminHeader: React.FC<AdminHeaderProps> = ({ onMenuToggle }) => {
  const { name, role } = useAdminAuth();

  return (
    // UPDATED: Added a 'Gradient Bottom Border' via the after element logic (handled by the div below)
    // Used backdrop-blur for a premium glass feel
    <header className="fixed top-0 right-0 left-0 lg:left-64 h-20 bg-white/80 backdrop-blur-md z-40 px-6 lg:px-8 flex items-center justify-between transition-all duration-300 shadow-[0_4px_30px_rgba(0,0,0,0.03)]">
      
      {/* DECORATIVE: Subtle Gradient Line at the bottom to kill the 'plain' look */}
      <div className="absolute bottom-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-[#006d5b] to-transparent opacity-30"></div>

      {/* Search Bar + Mobile Menu Toggle */}
      <div className="flex items-center gap-4">
         {/* Hamburger Button */}
         <button 
           onClick={onMenuToggle}
           className="lg:hidden text-gray-500 hover:text-[#006d5b] p-2 -ml-2 transition-colors"
         >
            <FaBars size={20} />
         </button>

         {/* Search Input - Improved shadow and focus ring */}
         <div className="relative group hidden sm:block">
           <FaSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-[#006d5b] transition-colors" size={14} />
           <input 
             type="text" 
             placeholder="Search here..." 
             className="bg-gray-50/50 border border-gray-200 text-sm rounded-full py-2.5 pl-10 pr-4 w-64 focus:ring-2 focus:ring-[#006d5b]/20 focus:border-[#006d5b] focus:bg-white focus:outline-none transition-all placeholder:text-gray-400 font-medium text-gray-700 shadow-inner"
           />
         </div>
      </div>

      {/* Right Actions */}
      <div className="flex items-center gap-6">
        {/* Bell Icon - Added a subtle hover glow */}
        <button className="relative p-2.5 bg-white border border-gray-100 hover:border-[#006d5b]/30 hover:shadow-lg hover:shadow-[#006d5b]/10 rounded-full text-gray-500 hover:text-[#006d5b] transition-all">
          <FaBell size={18} />
          <span className="absolute top-2 right-2.5 w-2 h-2 bg-red-500 rounded-full border-2 border-white animate-pulse"></span>
        </button>

        {/* User Profile Section */}
        <div className="flex items-center gap-3 pl-6 border-l border-gray-100">
          <div className="text-right hidden md:block">
            <p className="text-sm font-bold text-gray-800">{name || "Admin"}</p>
            <p className="text-[10px] text-gray-400 font-bold uppercase tracking-wider">{role ? role.replace('_', ' ') : "Super Admin"}</p>
          </div>
          
          {/* Profile Circle - Enhanced Shadow */}
          <div className="w-10 h-10 rounded-full bg-gradient-to-tr from-[#006d5b] to-[#4db6ac] p-[2px] cursor-pointer shadow-lg shadow-[#006d5b]/20 hover:scale-105 transition-transform">
             <div className="w-full h-full rounded-full bg-white flex items-center justify-center overflow-hidden">
                <FaUserCircle className="text-gray-300" size={32} />
             </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;